import React from 'react';
import ModalPassword from 'containers/ForgottenPassword/components/ModalPassword';
import AlertReminder from 'containers/Player/components/Alert/AlertReminder';
import PinForm from 'containers/PinForm/PinForm';
import useNodesLayoutData from './hooks/useNodesLayoutData';
import './styles.scss';
import EpgTransactions from '../../containers/Player/components/EpgTransactions/EpgTransactions';
import { Outlet } from 'react-router-dom';
import { useGetContentStyles } from './hooks/useGetContentStyles';
import { useSelector } from 'react-redux';
import { selectHeadbandState } from 'selectors/headband';

const NodesLayout = ({ children, location, params }) => {
  const { isVisible } = useSelector(selectHeadbandState);
  const {
    renderPictureInPicture,
    renderHeadBand,
    renderLoadingSpinner,
    renderModal,
    renderUserSuspendedModal,
    renderProfilesContainer,
    renderFooter,
    renderOldFooter,
    renderHeader,
    isInSearcher,
    renderLoader,
    showHeadBand,
  } = useNodesLayoutData({ location, params });
  const { contentDivRef, footerRef } = useGetContentStyles();

  const renderComponents = () => (
    <>
      {renderPictureInPicture()}
      {renderLoadingSpinner()}
      {renderHeadBand()}
      {<ModalPassword />}
    </>
  );

  return (
    <>
      {renderComponents()}
      <div
        id="main-wrap"
        className={`wrap ${showHeadBand && isVisible ? 'with-headband' : ''}`}
      >
        {renderLoader}
        {renderModal()}
        <AlertReminder />
        {renderProfilesContainer()}
        {renderHeader()}

        <div
          ref={contentDivRef}
          className={`content_div ${isInSearcher ? 'in-search' : ''} ${
            showHeadBand && isVisible ? 'with-headband' : ''
          }`}
        >
          <Outlet />
          {renderOldFooter(footerRef)}
        </div>
        <PinForm />
        <EpgTransactions isFromNodeMenu={true} />
        {renderUserSuspendedModal()}
        {renderFooter()}
      </div>
      <div className="WrapStyle" />
    </>
  );
};

export default NodesLayout;
